import { defineNuxtPlugin } from '#app'

function getScript() {
  return `
  var _mtm = window._mtm = window._mtm || [];
  _mtm.push({'mtm.startTime': (new Date().getTime()), 'event': 'mtm.Start'});
  (function() {
    var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
    g.async=true; g.src='https://cdn.matomo.cloud/aozinside.matomo.cloud/container_kUnbJfz2.js'; s.parentNode.insertBefore(g,s);
  })();
`
}

export default defineNuxtPlugin({
  name: 'aoz-analytics',
  setup(nuxtApp) {
    useHead({
      script: [
        {
          key: 'analytics-load',
          innerHTML: getScript(),
          tagPriority: 9003,
        },
      ],
    })

    // Where the dataLayer stuff is stored during SSR. We attach it to the
    // head after the page was rendered.
    const ssrDataLayer = useState<unknown[]>('ssrDataLayer', () => [])

    if (import.meta.server) {
      nuxtApp.hook('app:rendered', (ctx) => {
        ctx.ssrContext?.head.push({
          script: [
            {
              innerHTML: `window._mtm = ${JSON.stringify(ssrDataLayer.value)}`,
              tagPriority: -100,
            },
          ],
        })
        ssrDataLayer.value = []
      })
    }

    const router = useRouter()
    const { trackSwitchPage } = useAnalytics()
    const ssrTrackedUrl = useState('ssr_tracked_url', () => '')

    if (import.meta.server) {
      // The event is emitted by useDrupalRoute().
      nuxtApp.hook('vuepal:drupal-route', (ctx) => {
        if (!ctx.drupalRoute) {
          return
        }

        trackSwitchPage(
          router.options?.history?.state['back'],
          router.currentRoute.value.fullPath,
          ctx.metatags.title,
        )
        ssrTrackedUrl.value = router.currentRoute.value.fullPath
      })
    }

    if (import.meta.client) {
      let timeout: null | number = null
      let lastSet = ''

      router.afterEach((to) => {
        if (ssrTrackedUrl.value === to.fullPath) {
          return
        }
        ssrTrackedUrl.value = ''
        if (timeout) {
          window.clearTimeout(timeout)
        }
        timeout = window.setTimeout(() => {
          if (lastSet !== to.fullPath) {
            trackSwitchPage(
              router.options?.history?.state['back'],
              to.fullPath,
              document.title,
            )
            lastSet = to.fullPath
          }
        }, 1000)
      })
    }
  },
})
